import * as React from "react";

const SvgShare = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.647 20.375a1 1 0 0 0 .927.625h.031a1 1 0 0 0 .937-.651l5.696-15.3a1 1 0 0 0-1.287-1.286l-15.3 5.695a1 1 0 0 0-.651.937v.03a1 1 0 0 0 .625.928l6.425 2.597zM16.764 8.65 13.55 17.3l-1.547-3.888zM15.35 7.236l-4.762 4.762L6.7 10.45z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgShare;
